import { type FC, Fragment, type ReactNode } from 'react';

import { Button } from '@/components/ui/button';

interface InlineListButtonProps {
  index: number;
  onClick: () => void;
  children: ReactNode;
}

const InlineListButton: FC<InlineListButtonProps> = ({ index, onClick, children }) => {
  return (
    <Fragment>
      {index > 0 && ', '}
      <Button
        variant="ghost"
        onClick={onClick}
        className="inline h-auto px-1.5 py-0.5 align-baseline text-sm font-normal text-foreground hover:bg-accent rounded-md"
      >
        {children}
      </Button>
    </Fragment>
  );
};

export default InlineListButton;
